



































































import { i18n } from '@/i18n/i18n-setup';
import { Component, Vue } from 'vue-property-decorator';
import { General } from '@/services/General';
import { DropDownItem } from '@/services/DropDownItem';
import axios from 'axios';

class DocumentAttachmentDto {
    id?: string;
    fileName: string;
    sessionId: string;
    processId?: string;
    updateProgress?: string;
    status?: string;
    documentAttachmentMarkets?: Array<DocumentAttachmentMarketDto>

    constructor(
        id?: string,
        fileName?: string,
        sessionId?: string,
        processId?: string,
        status?: string,
        documentAttachmentMarkets?: Array<DocumentAttachmentMarketDto>
    ) {
        this.id = id;
        this.fileName = fileName;
        this.sessionId = sessionId;
        this.processId = processId;
        this.status = status;
        this.documentAttachmentMarkets = documentAttachmentMarkets;
    }

}

class DocumentAttachmentMarketDto {
    idDocumentAttachment?: string;
    idChannel?: number;
    idCulture?: string;

    constructor(
        idDocumentAttachment?: string,
        idChannel?: number,
        idCulture?: string,
    ) {
        this.idDocumentAttachment = idDocumentAttachment;
        this.idChannel = idChannel;
        this.idCulture = idCulture;
    }
}

interface Option {
    value?: number
    text: string
}

@Component({
    components: {

    }
})

export default class DocumentAttachmentCreation extends Vue {
    loading: boolean = true;
    isOnSubmit: boolean = false;
    uploadPerc: number = 0;
    idSession: string = "";
    fileName: string = "";
    fileValidation: boolean = true;

    cultureSelected: Array<string> = null;
    channelSelected: Array<number> = null;
    dropDownCultures: DropDownItem[] = null;
    dropDownChannels: Array<any> = null;

    async mounted() {
        this.loading = true;

        this.dropDownChannels = await this.getDropDownChannels();
        this.dropDownCultures = await this.getDropDownCulters(); 
          
        this.loading = false;
    }

    async getDropDownChannels(): Promise<Array<any>> {
        try {
            let channel: DropDownItem = new DropDownItem();
            let channelList: DropDownItem[] = [];
            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/net20/GetAllChannelsDetail'), {
                responseType: "json",
                withCredentials: true
            });
            if (response.data) {
                response.data.forEach(element => {
                    channel = new DropDownItem();
                    channel.idDropDownItem = element.id;
                    channel.itemText = element.description;
                    channelList.push(channel);
                });
                return General.SetOptionsDropDown(channelList, false);
            }
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        }
    }

    async getDropDownCulters(): Promise<Array<any>> {
        try {
            let culture: DropDownItem = new DropDownItem();
            let cultureList: DropDownItem[] = [];
            let response = await axios.get<any[]>(
                General.GetApiUrl('/api/Net20/GetCulturesOnlyUsed'), {
                responseType: "json",
                withCredentials: true
            })
            if (response.data) {
                response.data.forEach(element => {
                    culture = new DropDownItem();
                    culture.idDropDownItem = element.idCulture;
                    culture.itemText = element.country.name + " - " + element.language.name;
                    cultureList.push(culture);
                })
                cultureList.sort((x, y) => x.itemText.localeCompare(y.itemText));
                return General.SetOptionsDropDown(cultureList, false);
            }
        } catch (err) {
            General.HandleError(err, this);
            return null;
        }

    }

    submitDocument() {
        this.isOnSubmit = true;
        this.fileValidation = true;
        if (this.idSession !== undefined && this.idSession != null && this.idSession !== "") {
            let message = i18n.t('NET20.CUSTOMER_CREATE_DOC_QUESTION') as string;
            General.confirm(
                message,
                this,
                async () => {
                    await this.submitDocumentDo();
                    this.isOnSubmit = false;
                    this.$emit('refreshResults')
                }
            );
        } else {
            this.fileValidation = false;
            let message = i18n.t('NET20.CUSTOMER_ALERT_DOC') as string;
            General.showAlertDanger(message, this);
        }
    }

    async submitDocumentDo() {

        let document: DocumentAttachmentDto = {
            fileName: this.fileName,
            sessionId: this.idSession,
            // idChannel: this.channelSelected as number,
            // idCulture: this.cultureSelected,
        }

        let documentAttachmentMarkets = new Array<DocumentAttachmentMarketDto>();
        this.channelSelected.forEach(channel => {
            this.cultureSelected.forEach(culture => {
                let market = new DocumentAttachmentMarketDto();
                market.idChannel = channel;
                market.idCulture = culture;

                documentAttachmentMarkets.push(market);
            });
        });

        document.documentAttachmentMarkets = documentAttachmentMarkets;

        try {

            await axios.post<any>(
                General.GetApiUrl('/api/net20/CreateDocumentAttachments'),
                document,
                {
                    withCredentials: true,
                    responseType: 'json',
                },
            );
            this.$bvModal.hide('document-attachments-creation-modal');
            let message = i18n.t('NET20.CUSTOMER_DOC_UPLOAD_SUCCESS') as string;
            General.showAlertSuccess(message, this);

        } catch (error) {
            this.fileValidation = false;
            if (error.response.status as number === 409 as number) {
                console.log(error.response);
                let message = i18n.t('NET20.CUSTOMER_FILENAME_ERROR') as string;
                General.showAlertDanger(message, this);
            } else {
                General.HandleError(error, this);
            }
        }

    }



    showSuccessAlert(sessionId: any) {
        this.idSession = sessionId;
        this.uploadPerc = 100;
        this.fileValidation = true;
    }

    getFileName(fileName: string) {
        this.fileName = fileName;
    }

    updateProgress(e: any) {
        this.uploadPerc = e;
    }


    checkAllValues(): boolean {
        if (
            this.validationSelect(this.channelSelected != null && this.channelSelected.length > 0, true) &&
            this.validationSelect(this.cultureSelected != null && this.cultureSelected.length > 0, true)
        ) {
            return true
        }
        return false
    }
    validationSelect(validationResult: boolean, isOnSubmit: boolean): boolean {
        if (isOnSubmit) {
            return validationResult
        }
        return null;
    }
}
